import { useState } from 'react';
import { useInit } from '../../../../../Contexts/InitProvider';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import InputField, {
    InputCheckbox,
    SelectOption,
    addOption
} from '../../../../../utils/InputField';
import { ApiCreateServicePackage } from '../../ServiceOperation';

function AddPackageModal({ closeModal, handleReload, data }) {
    console.log(data);
    const [formData, setFormData] = useState({
        AppServiceId: data?.id,
        PackageName: '',
        PackageForRole: 'customer',
        IsPublic: false,
        Status: 'active'
    });
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const { initInfo } = useInit();
    const { setMessage } = useTemplate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'IsPublic') {
            setFormData((d) => ({ ...d, [name]: !formData.IsPublic }));
            return;
        }
        setFormData((d) => ({ ...d, [name]: value }));
    };

    const handleAddPackage = (e) => {
        e.preventDefault();
        setLoading(true);
        ApiCreateServicePackage(data?.id, formData, setIsError)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                closeModal();
                handleReload();
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };

    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleAddPackage}>
            <div className="flex flex-col gap-y-3 mb-4">
                <InputField
                    label="Package Name"
                    name="PackageName"
                    placeholder="Enter Package Name..."
                    formData={formData}
                    onChange={handleChange}
                />
                <SelectOption
                    label="Package Role"
                    name="PackageForRole"
                    formData={formData}
                    onChange={handleChange}
                    options={initInfo?.roles
                        ?.filter((el) => el.key !== 'admin')
                        ?.map((item) => addOption(item?.key, item?.title, item?.key))}
                    disabled
                />
                <InputCheckbox
                    label="IsPublic"
                    name="IsPublic"
                    formData={formData}
                    onChange={handleChange}
                    text="Is this package public?"
                />
            </div>

            <div className="flex gap-x-2 justify-end">
                <ButtonCancel title="Cancel" onClick={closeModal} />
                <ButtonPrimary title="Add" btnType="submit" loading={loading} onClick={null} />
            </div>
        </form>
    );
}

export default AddPackageModal;
